import {ChangeDetectionStrategy, Component} from '@angular/core';
import {LensesMainComponent} from '../../lenses/lenses-main/lenses-main.component';

@Component({
  selector: 'people-lenses-wrapper',
  standalone: true,
  imports: [LensesMainComponent],
  templateUrl: './people-lenses-wrapper.component.html',
  styleUrl: './people-lenses-wrapper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PeopleLensesWrapperComponent {}
